module.exports = __webpack_public_path__ + "4280a798a550c85b225cfc460e3e507f.svg";